import consumer from "./consumer"

const root = document.getElementById("admin-order-notification-root")

if (root) {
  consumer.subscriptions.create("AdminOrdersChannel", {
    received(data) {
      showOrderNotification(data)
    }
  })
}

function showOrderNotification(data) {
  if (!root) return

  const message = data.message || "Novo pedido recebido."
  const details = data.details || ""
  const url = data.url

  const toast = document.createElement("div")
  toast.className = "pointer-events-auto w-full max-w-sm rounded-xl border border-emerald-200 bg-white p-4 shadow-lg"

  const title = document.createElement("p")
  title.className = "text-sm font-semibold text-emerald-700"
  title.textContent = message
  toast.appendChild(title)

  if (details) {
    const detailsNode = document.createElement("p")
    detailsNode.className = "mt-1 text-xs text-slate-600"
    detailsNode.textContent = details
    toast.appendChild(detailsNode)
  }

  if (url) {
    const link = document.createElement("a")
    link.className = "mt-3 inline-flex text-xs font-medium text-[var(--primary)] hover:underline"
    link.href = url
    link.textContent = "Ver pedido"
    toast.appendChild(link)
  }

  root.appendChild(toast)

  window.setTimeout(() => {
    toast.classList.add("opacity-0", "transition", "duration-300")
    window.setTimeout(() => toast.remove(), 300)
  }, 7000)
}
